/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { PropTypes } from 'react'
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'
import { Link } from 'react-router-dom'
import constants from 'constants'
import styles from './ActionMenu.scss'

const ActionMenu = ({ menu, handleOnClick }) => (
  <IconMenu
    className={styles.iconMenu}
    icon="more_vert"
    position="topLeft"
    menuRipple
  >
    {menu.map(item => (
      <div key={item.key} >
        {String(item.type) === constants.ADMINCENTRE_TYPE.LINK ? <Link key={item.key} to={item.path}>
          <MenuItem
            caption={item.label}
            className={styles.item}
            onClick={() => handleOnClick()}
            value={item.label}
          />
        </Link> :
        <MenuItem
          caption={item.label}
          className={styles.item}
          onClick={() => handleOnClick(item.label, item.type)}
          value={item.label}
        /> }
      </div>
    ))}
  </IconMenu>
)

ActionMenu.propTypes = {
  children: PropTypes.node,
  handleAction: PropTypes.func,
  onMouseDown: PropTypes.func,
}

export default ActionMenu



// WEBPACK FOOTER //
// ./src/components/ActionMenu/ActionMenu.js